import { t } from '@lingui/core/macro';
import { useFormikContext } from 'formik';
import { EntryPickerDialog } from 'app/domains/common-ui/pickers';
export function FilesystemEntriesField(props) {
    const { onClose } = props;
    const { values, setFieldValue, submitForm } = useFormikContext();
    const handleSubmit = (entries) => {
        const ids = entries.map(({ id }) => id);
        setFieldValue('value', ids);
        return submitForm();
    };
    return (<EntryPickerDialog multiselect initialEntryIds={values.value} dialogTitle={t({
            message: 'Select related documents',
            comment: 'Metadata: Filesystem entries picker dialog title',
        })} submitLabel={t({
            message: 'Select',
            comment: 'Metadata: Filesystem entries picker dialog submit button label',
        })} onClose={onClose} onSubmit={handleSubmit}/>);
}
